import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@nasam/kernel";
import type { NotificationsListQuery, NotificationsRepository } from "../domain";

function params(query: NotificationsListQuery | undefined) {
  return query === undefined ? undefined : { ...query };
}

export function useNotificationsQuery(
  repository: NotificationsRepository,
  query?: NotificationsListQuery,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.notifications.list(params(query)),
    queryFn: () => repository.list(query),
    enabled,
  });
}

export function useNotificationsSummaryQuery(repository: NotificationsRepository) {
  return useQuery({
    queryKey: queryKeys.notifications.summary(),
    queryFn: () => repository.summary(),
  });
}

function useInvalidatingMutation<TInput, TResult>(
  mutationFn: (input: TInput) => Promise<TResult>,
) {
  const client = useQueryClient();
  return useMutation({
    mutationFn,
    onSuccess: async () =>
      client.invalidateQueries({ queryKey: queryKeys.notifications.all }),
  });
}

export function useMarkNotificationReadMutation(
  repository: NotificationsRepository,
) {
  return useInvalidatingMutation((id: string) => repository.markAsRead(id));
}

export function useMarkAllNotificationsReadMutation(
  repository: NotificationsRepository,
) {
  return useInvalidatingMutation(() => repository.markAllAsRead());
}
